import { ClassProvider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { ValidateRfService } from '../../../domain/representative/services/validate-rf.service';

export class ValidateRfServiceInstruction implements ClassProvider {
  provide = Types.ValidateRfService;
  deps = [Types.RepresentativeRepository];
  useClass = ValidateRfService;
}
